import { ConfirmDialog, LinearProgress, Typography } from '@occc-app/design-system';

export type DeactivateWalletConfirmDialogProps = {
  onClose: () => void;
  onConfirm: () => void;
  loading: boolean;
  walletName: string;
};

export const DeactivateWalletConfirmDialog: React.FC<DeactivateWalletConfirmDialogProps> = ({
  onClose,
  onConfirm,
  loading,
  walletName,
}) => {
  return (
    <ConfirmDialog
      dialogTitle='Deactivate Wallet'
      onClose={onClose}
      open
      maxWidth='xs'
      confirmButtonText='Deactivate'
      confirmButtonProps={{
        onClick: onConfirm,
        disabled: loading,
      }}
    >
      {loading && <LinearProgress />}
      <Typography>
        {`Are you sure you would like to deactivate "${walletName}" from your program?`}
      </Typography>
    </ConfirmDialog>
  );
};
